import React, { useState } from 'react';
import styles from './ActivityHistoryList.module.css';
import { describeHistoryEntry } from './activityHistoryFormat';

/**
 * ActivityHistoryList
 *
 * Linha do tempo do histórico (quem cadastrou/alterou e quando), usada no
 * drawer do agendamento e na aba Histórico do paciente.
 *
 * @param {Object[]} entries - entradas do endpoint, mais recente primeiro
 * @param {Object} labels - rótulos resolvidos pelo endpoint
 * @param {boolean} isLoading
 * @param {string|null} error
 * @param {boolean} [showAppointment] - diz de qual agendamento é cada entrada
 * @param {number} [initialCount] - quantas mostrar antes de "Ver tudo" (0 = todas)
 */
function ActivityHistoryList({ entries, labels, isLoading, error, showAppointment = false, initialCount = 0 }) {
  const [expanded, setExpanded] = useState(false);

  if (isLoading && entries.length === 0) {
    return <p className={styles.message}>Carregando histórico…</p>;
  }
  if (error) {
    return <p className={styles.message}>{error}</p>;
  }
  if (entries.length === 0) {
    return <p className={styles.message}>Nenhum registro no histórico.</p>;
  }

  const limited = initialCount > 0 && !expanded && entries.length > initialCount;
  const visible = limited ? entries.slice(0, initialCount) : entries;
  const hasLegacy = visible.some((entry) => entry.legacy);

  return (
    <div className={styles.container}>
      <ol className={styles.timeline}>
        {visible.map((entry) => {
          const item = describeHistoryEntry(entry, labels, showAppointment);
          return (
            <li key={item.key} className={styles.item}>
              <span className={styles.dot} aria-hidden="true" />
              <div className={styles.content}>
                <div className={styles.titleRow}>
                  <span className={styles.title}>{item.title}</span>
                  <span className={styles.when}>{item.when}</span>
                </div>
                {item.context && <span className={styles.context}>{item.context}</span>}
                {item.lines.map((line) => (
                  <span key={line} className={styles.line}>{line}</span>
                ))}
                <span className={styles.author}>por {item.author}</span>
              </div>
            </li>
          );
        })}
      </ol>

      {limited && (
        <button type="button" className={styles.moreBtn} onClick={() => setExpanded(true)}>
          Ver histórico completo ({entries.length})
        </button>
      )}

      {hasLegacy && (
        <p className={styles.note}>
          Registros anteriores ao histórico mostram só a data do cadastro.
        </p>
      )}
    </div>
  );
}

export default ActivityHistoryList;
